import {
  deleteCorporateOnlyLessonDefinition,
  getCorporateOnlyLessonDefinitionDetail,
} from '../../../api/corporateOnlyLessonDefinitionApi'
import { keysToCamel } from '../../../helpers/keys-to-case'
import { getDayOfWeekLabel } from '../../../helpers/utils'
import AuthPermission from '../../../high-order-components/auth-permission'
import translate from '../../../i18n'
import { PermissionsEnum } from '../../../share-types'
import { IStudioTranslation } from '../../studios-container/share-type'
import { CorporateOnlyLessonDefinition as CorporateOnlyLessonDefinitionType } from '../share-type'
import styles from './corporate-only-lesson-definition.module.less'
import { Button, Descriptions, Modal, notification, Space, Tag } from 'antd'
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { compose } from 'redux'

interface IProps {
  corporateOnlyLessonDefinitionDetail: CorporateOnlyLessonDefinitionType
}

const CorporateOnlyLessonDefinitionDescriptions = ({
  corporateOnlyLessonDefinitionDetail,
}: IProps) => {
  const { studio, daysOfWeek, timeRangeStart, timeRangeEnd } = corporateOnlyLessonDefinitionDetail

  const studioName =
    studio.id +
    '-' +
    studio?.studioTranslations
      .map((studioTranslation: IStudioTranslation) => studioTranslation.name)
      .join('/')

  return (
    <Descriptions
      bordered
      column={1}
      styles={{ root: { width: '100%' }, label: { fontWeight: 600 } }}
    >
      <Descriptions.Item label={translate('corporateOnlyLessonDefinitions.studioId')}>
        {studioName}
      </Descriptions.Item>
      <Descriptions.Item label={translate('corporateOnlyLessonDefinitions.daysOfWeek')}>
        {daysOfWeek.map(d => (
          <Tag key={d}>{getDayOfWeekLabel(d)}</Tag>
        ))}
      </Descriptions.Item>
      <Descriptions.Item label={translate('corporateOnlyLessonDefinitions.timeRange')}>
        {timeRangeStart && timeRangeEnd ? timeRangeStart + ' - ' + timeRangeEnd : ''}
      </Descriptions.Item>
    </Descriptions>
  )
}

const CorporateOnlyLessonDefinition = () => {
  const params = useParams()
  const navigate = useNavigate()
  const [corporateOnlyLessonDefinitionId] = useState<string | undefined>(params?.id)
  const [corporateOnlyLessonDefinitionDetail, setCorporateOnlyLessonDefinitionDetail] =
    useState<CorporateOnlyLessonDefinitionType>()

  useEffect(() => {
    if (corporateOnlyLessonDefinitionId) {
      getCorporateOnlyLessonDefinitionDetail(Number(corporateOnlyLessonDefinitionId)).then(
        (res: any) => {
          setCorporateOnlyLessonDefinitionDetail(keysToCamel(res))
        },
      )
    }
  }, [corporateOnlyLessonDefinitionId])

  const toEdit = () => {
    navigate(`/corporate-only-lesson-definitions/${corporateOnlyLessonDefinitionId}/edit`)
  }

  const goBack = () => {
    navigate('/corporate-only-lesson-definitions')
  }

  const deleteAction = () => {
    Modal.confirm({
      title: translate('corporateOnlyLessonDefinitions.deleteTitle'),
      onOk: async () => {
        await deleteCorporateOnlyLessonDefinition(Number(corporateOnlyLessonDefinitionId))
        notification.success({
          message: translate('corporateOnlyLessonDefinitions.deleteSuccess'),
        })
        goBack()
      },
    })
  }

  return (
    <div className={styles['corporate-only-lesson-definition-desc-wrapper']}>
      {corporateOnlyLessonDefinitionDetail && (
        <CorporateOnlyLessonDefinitionDescriptions
          corporateOnlyLessonDefinitionDetail={corporateOnlyLessonDefinitionDetail}
        />
      )}
      <Space className={styles['button-group']}>
        <AuthPermission permission={PermissionsEnum.CORPORATE_ONLY_LESSON_DEFINITIONS_WRITE}>
          <Button type="primary" onClick={toEdit}>
            {translate('edit')}
          </Button>
        </AuthPermission>

        <Button onClick={goBack}>{translate('goBack')}</Button>

        <AuthPermission permission={PermissionsEnum.CORPORATE_ONLY_LESSON_DEFINITIONS_WRITE}>
          <Button type="primary" danger onClick={deleteAction}>
            {translate('delete')}
          </Button>
        </AuthPermission>
      </Space>
    </div>
  )
}

export default compose()(CorporateOnlyLessonDefinition)
